import * as actionTypes from '../../Constants/customFieldActionTypes';

export function isCfEdited(isCustomFieldEdted) {
    return {
        type: actionTypes.CUSTOM_FIELD_EDITED,
        payload: { isCustomFieldEdted: isCustomFieldEdted }
    }    
}

export function customFieldEdited(isCustomFieldEdted) {
    return  dispatch => {        
        return dispatch(isCfEdited(isCustomFieldEdted))
    }
}

export function showLoading(isloading) {
    return dispatch =>
        dispatch({
            type: actionTypes.LOADING,
            payload: { isloading: isloading }
        });
    
}